import React, { Fragment, memo, useMemo } from "react";
import methodModel from "../../../methods/methods";
import "./style.scss";
import Select from "react-select";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import CreatableSelect from "react-select/creatable";

const Html = ({
  isLoading,
  options,
  dynamicStyle = false,
  onFocus = () => { },
  className = "",
  selectedValues,
  onInputChange = (e: any) => { },
  filterOption,
  handleChange = () => { },
  displayValue,
  id = "",
  placeholder,
  setOptions,
  required = false,
  disabled,
  onBlur,
  name = "",
  content = '',
  hideDefaultPosition = false,
  theme = "normal",
  isClearable = true,
}: any) => {
  const hasSelectedValue =
    selectedValues !== undefined &&
    selectedValues !== null &&
    selectedValues !== "";

  const categoryVal = () => {
    let ext = options && options.find((item: any) => item?.id == selectedValues);
    return ext
      ? { value: ext.id, label: ext[displayValue] }
      : hasSelectedValue
      ? {
          value: selectedValues,
          label: selectedValues,
        }
      : "";
  };

  const dropOptions = useMemo(() => {
    let opt = options?.map((itm: any) => {
      return { value: itm?.id, label: itm?.[displayValue] };
    }) || []

    if (!opt?.length && hasSelectedValue) {
      opt = [{
        value: selectedValues,
        label: selectedValues
      }]
    }
    return opt
  }, [options, selectedValues, hasSelectedValue])

  return (
    <>{theme === "multiple" ? (
      <Select
        isMulti
        options={dropOptions}
        placeholder={placeholder}
        onBlur={onBlur}
        value={
          Array.isArray(selectedValues)
            ? dropOptions.filter((opt: any) => selectedValues.includes(opt.value))
            : selectedValues
              ? dropOptions.filter((opt: any) =>
                selectedValues.split(",").includes(opt.value)
              )
              : []
        }
        onFocus={onFocus}
        isClearable={isClearable}
        name={name}
        onInputChange={onInputChange}
        onChange={(selectedOptions: any) => {
          const values = selectedOptions
            ? selectedOptions.map((o: any) => o.value).join(",")
            : "";
          handleChange(values); // <-- returns comma-separated string
        }}
        className="text-gray-700 block text-sm options_classs"
        isDisabled={!!disabled}
        required={required}
        isLoading={isLoading}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    ) : theme == "search" ? (
      <>
        <div className={`${className || "capitalize"}`}>
          <Select
            options={dropOptions}
            placeholder={placeholder}
            onBlur={onBlur}
            value={categoryVal()}
            onFocus={onFocus}
            isClearable={isClearable}
            name={name}
            filterOption={filterOption}
            onInputChange={onInputChange}
            onChange={(e: any) => handleChange(e?.value ?? "")}
            className="text-gray-700 block text-sm options_classs"
            isDisabled={disabled ? true : false}
            required={required}
            isLoading={isLoading}
            menuPortalTarget={document.body} // render menu at the top-level
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // set max z-index
            }}
          // menuPlacement="auto"
          // menuIsOpen={false}
          />
        </div>

      </>
    ) :
      theme === "create" ? (
        <CreatableSelect
          options={dropOptions}
          placeholder={placeholder}
          onBlur={onBlur}
          value={categoryVal()}
          onFocus={onFocus}
          // menuPlacement="auto"
          isClearable={isClearable}
          name={name}
          onInputChange={onInputChange}
          onChange={(e: any) => handleChange(e?.value || "")}
          onCreateOption={(inputValue: string) => {
            const newOption = {
              id: inputValue,
              name: inputValue,
            };
            handleChange(inputValue || "")
            setOptions((prev: any) => {
              let data = prev || []
              return ([...data, newOption])
            })
            // handleChange(inputValue); // or full newOption if needed
            // Optionally add new option to your state if maintaining options locally
          }}
          formatCreateLabel={(inputValue) => `Click here to add "${inputValue}"`}
          className="text-gray-700 block text-sm options_classs "
          isDisabled={disabled ? true : false}
          required={required}
          isLoading={isLoading}
        />) : (
        <>
          <div className="selectDropdown">
            <input
              type="hidden"
              name={name}
              required={required}
              value={selectedValues}
            />
            <div className="">
              <Menu as="div" className="relative list_box_active_state ml-auto">
                <div>
                  <Menu.Button
                    disabled={disabled}
                    id={"dropdownMenuButton" + id}
                    className={`capitalize border flex text-[#808080] justify-between gap-3 align-items-center rounded w-full ${className}`}
                  >
                    <span className="py-2 pl-3 text-[14px]">
                      {hasSelectedValue
                        ? methodModel.find(options, selectedValues, "id")?.[
                        displayValue
                        ] || placeholder
                        : placeholder}
                    </span>

                    <ChevronDownIcon
                      className="text-gray-400 border-l h-[37px] p-2 w-[37px]"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items
                    className={`${dynamicStyle ? "" : "max-h-60"
                      }  focus:!outline-[#540C0F] focus:!outline text-sm absolute !z-10 ${className ? className : "min-w-[auto] lg:min-w-[100%]  md:min-w-[180px]"
                      }  right-0 shadow-lg !py-2 !mt-1.5 overflow-y-auto overflow-x-hidden bg-white  rounded-lg scrollbar capitalize`}
                  >
                    <div className="mt-2">

                      {content ? <>
                        {content}
                      </> : <>

                        {!isClearable ? null : (
                          <>
                            <Menu.Item disabled={disabled}>
                              {({ active }) => (
                                <a
                                  className={
                                    selectedValues == ""
                                      ? "text-gray-700 block px-4 py-2 text-sm active"
                                      : "text-gray-700 block px-4 py-2 text-sm"
                                  }
                                  onClick={() => handleChange("")}
                                >
                                  {placeholder}
                                </a>
                              )}
                            </Menu.Item>
                          </>
                        )}
                        {options &&
                          options.map((itm: any) => {
                            return (
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    className={
                                      selectedValues == itm.id
                                        ? "text-gray-700 block px-4 py-2 text-sm active"
                                        : "text-gray-700 block px-4 py-2 text-sm"
                                    }
                                    onClick={() => handleChange(itm.id)}
                                    key={itm.id}
                                  >
                                    {itm[displayValue]}
                                  </a>
                                )}
                              </Menu.Item>
                            );
                          })}
                      </>}


                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default memo(Html);
